module.exports = __webpack_public_path__ + "static/media/gallery_bandname.2a282489.png";